// configuration.js
var DKT = DKT || {};
DKT.configuration = function() {
  return {
    MAP_CENTER_COORDINATES: [43.3117299, -1.9790757],
    PATHS_FAVORITE_COLOR: "#FF0000",
    PATHS_MAIN_COLOR: "#0D3F90",
    PATHS_POLYLINE_WEIGHT_DEFAULT: 7,
    PATHS_POLYLINE_WEIGHT_SELECTED: 8,
    TAMBORRADA_DAY: "2026-01-20",
    TEXT_MAP_SCROLL_MAC: "Mantén pulsada la tecla \u2318 mientras te desplazas para acercar o alejar el mapa",
    TEXT_MAP_SCROLL: "Mantén pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",
    TEXT_MAP_TOUCH: "Para mover el mapa, utiliza dos dedos",
    URL_IMG_TAMBORZON_OFF: "/templates/t3_bs3_blank/images/bihotza-positivo-off.png",
    URL_IMG_TAMBORZON_ON: "/templates/t3_bs3_blank/images/bihotza-positivo.png"
  };
};
